import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import moment from 'moment'

// components
import AppCard from '../../components/AppCard'
import AppTable from 'src/components/AppTable'
import AppModalConfirmation from 'src/components/modal/AppModalConfirmation'

// helpers
import Axios from '../../helpers/axios'
import { columnTimeOffRequestList } from '../../components/table-column/TableColumnList'
import { formUrlQuery } from '../../helpers/format-queries'
import useToastMessage from 'src/helpers/toast-message'

const TimeOffRequestList = () => {
  const navigate = useNavigate()
  const { showSuccess, showError } = useToastMessage();

  const [showConfirmDelete, setShowConfirmDelete] = useState({ show: false, item: {} })

  const [timeOffRequestList, setTimeOffRequestList] = useState(null);
  const [timeOffRequestListCount, setTimeOffRequestListCount] = useState(0);
  const [timeOffRequestListPerPage, setTimeOffRequestListPerPage] = useState(10);
  const [activeTimeOffRequestListPage, setActiveTimeOffRequestListPage] = useState(1);
  const [searchTimeOffRequestListFilter, setSearchTimeOffRequestListFilter] = useState("");
  const [columnTimeOffRequestListSorter, setColumnTimeOffRequestListSorter] = useState({ column: "createdAt", state: "desc" });

  useEffect(() => {
    let queries = {
      search: searchTimeOffRequestListFilter,
      limit: timeOffRequestListPerPage,
      offset: timeOffRequestListPerPage * activeTimeOffRequestListPage - timeOffRequestListPerPage,
      sort:
        (columnTimeOffRequestListSorter &&
          `${columnTimeOffRequestListSorter.column}%${columnTimeOffRequestListSorter.state}`) ||
        "",
    };
    queries = formUrlQuery(queries);
    fetchAllTimeOffRequests(queries);
  }, [
    searchTimeOffRequestListFilter,
    timeOffRequestListPerPage,
    activeTimeOffRequestListPage,
    columnTimeOffRequestListSorter,
  ]);

  const handleSearchItems = (search) => {
    setActiveTimeOffRequestListPage(1)
    setSearchTimeOffRequestListFilter(search);
  }

  const fetchAllTimeOffRequests = (queries) => {
    Axios({
      method: "get",
      url: `/api/tracker/v1/leave/request/list?${queries}`
    })
      .then(({ data }) => {
        let tempTimeOffRequestList = data?.value
        tempTimeOffRequestList = tempTimeOffRequestList.map((item) => {
          return {
            ...item,
            employee_name: item?.employee ? `${item?.employee?.first_name} ${item?.employee?.last_name}` : '-',
            employee_status: item?.employee ? item?.employee?.status : '-',
            time_off_type: item?.leave_type ? (item?.unpaid_category === "LOP" ? `${item?.leave_type?.name} (LOP)` : item?.leave_type?.name) : '-',
            duration: item?.days_count ? item?.hours_count ? Number(item?.hours_count) >= 4 ? `${item?.days_count} Days (> 4 working hours)` : `0 Days (< 4 working hours)` : `${item?.days_count} Days` : '-',
            submission_date: item?.createdAt ? moment(item?.createdAt).format('YYYY-MM-DD') : '-',
            status: item?.status ? item?.status?.includes('_') ? item?.status.replace('_', ' ')?.toUpperCase() : item?.status?.toUpperCase() : '-',
          }
        })
        setTimeOffRequestList(tempTimeOffRequestList);
        if (activeTimeOffRequestListPage === 1) {
          setTimeOffRequestListCount(data?.count);
        }
      })
      .catch((err) => {
        console.error(err);
        const errMsg = err?.response?.data?.message
        showError(errMsg)
      });
  };

  const handleDeleteConfirmation = () => {
    Axios({
      method: "delete",
      url: `/api/tracker/v1/leave/request/delete/${showConfirmDelete?.item?.id}`,
    })
      .then(({ data }) => {
        if (data?.success) {
          setShowConfirmDelete({ show: false, item: {} })
          fetchAllTimeOffRequests(formUrlQuery({
            search: searchTimeOffRequestListFilter,
            limit: timeOffRequestListPerPage,
            offset: timeOffRequestListPerPage * activeTimeOffRequestListPage - timeOffRequestListPerPage,
            sort:
              (columnTimeOffRequestListSorter &&
                `${columnTimeOffRequestListSorter.column}%${columnTimeOffRequestListSorter.state}`) ||
              "",
          }))
          showSuccess('Time-off request has been successfully deleted')
          window.location.reload()
        }
      })
      .catch((err) => {
        console.error(err);
        const errMsg = err?.response?.data?.message
        showError(errMsg)
      });
  }

  const handleOnRowClick = (item, columnName) => {
    if (columnName !== 'action') {
      navigate(`/time-off-request/details/${item.id}`)
    }
  }

  return (
    <>
      {
        showConfirmDelete?.show && (
          <AppModalConfirmation
            confirmationType='delete-item'
            itemName={`Time-Off Request - ${showConfirmDelete?.item?.name}`}
            itemDetails={showConfirmDelete.item}
            itemType={showConfirmDelete.type}
            itemIndex={showConfirmDelete?.index}
            showModal={showConfirmDelete}
            setShowModal={setShowConfirmDelete}
            handleConfirmation={handleDeleteConfirmation}
          />
        )
      }
      <AppCard
        className='mb-4'
        headerTitle={<h4>Time-Off Request List</h4>}
        bodyContent={
          <AppTable
            timeOffRequestListPage
            tableFilter
            setShowConfirmDelete={setShowConfirmDelete}
            tableColumns={columnTimeOffRequestList}
            tableContent={timeOffRequestList}
            contentPerPage={timeOffRequestListPerPage}
            activeContentPage={activeTimeOffRequestListPage}
            contentCount={timeOffRequestListCount}
            searchContentFilter={searchTimeOffRequestListFilter}
            setActiveContentPage={setActiveTimeOffRequestListPage}
            setSearchContentFilter={handleSearchItems}
            setContentPerPage={setTimeOffRequestListPerPage}
            setColumnContentSorter={setColumnTimeOffRequestListSorter}
            handleOnRowClick={handleOnRowClick}
            isClickable={true}
          />
        }
      />
    </>
  )
}

export default TimeOffRequestList
